export default "__VITE_PUBLIC_ASSET__f15a88ae__"